import React from "react";

export default function BasicInfoStep({ dashboardData, handleDashboardDataChange, isEditingDashboard }) {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <div className="bg-[#003366]/10 p-4 rounded-lg mb-6 border border-[#003366]/20">
        <p className="text-[#004488]">
          Start by entering a name for your new dashboard.
          {isEditingDashboard && (
            <span className="block text-gray-600 text-sm mt-1">
              Dashboard name cannot be modified when editing.
            </span>
          )}
        </p>
      </div>
      
      <div className="space-y-6">
        <div>
          <label
            htmlFor="dashboardName"
            className="block text-sm font-medium text-slate-700 mb-2"
          >
            Dashboard Name <span className="text-red-500">*</span>
            {isEditingDashboard && (
              <span className="text-gray-500 text-xs ml-2">(Cannot be modified)</span>
            )}
          </label>
          <input
            type="text"
            id="dashboardName"
            value={dashboardData.name}
            onChange={(e) =>
              handleDashboardDataChange("name", e.target.value)
            }
            disabled={isEditingDashboard}
            className={`w-full p-2.5 text-sm text-slate-700 border border-gray-300 rounded-md transition-all duration-200 ${
              isEditingDashboard 
                ? 'bg-gray-100 text-gray-600 cursor-not-allowed' 
                : 'bg-white focus:outline-none focus:ring-2 focus:ring-slate-100 focus:border-slate-500 hover:border-slate-400'
            }`}
            placeholder="Enter dashboard name"
          />
        </div>
      </div>
    </div>
  );
}